import AssetPreviewModal from "./AssetPreviewModal";

export default AssetPreviewModal;
